export default "__VITE_ASSET__D$7T88hL__"